// Ported from the Lovable "Generador de Slides" (auto-promo-slides). Draws a 2160×2400 slide on a canvas.
const BOX_W = 1000;
const BOX_H = 720;
const NAVY = "#0a1f5c";
const CONTACT = ["C/ Granada 4, Local 3 · Olula del Rio", "Tel. 661 666 916", "sobrinosport@gmail.com", "@sobrino sport"];
export const clamp = (v, a, b) => Math.min(b, Math.max(a, v));

export const loadImg = (src, cross = false) =>
  new Promise((res) => {
    const im = new Image();
    if (cross) im.crossOrigin = "anonymous";
    im.onload = () => res(im);
    im.onerror = () => res(null);
    im.src = src;
  });

export const computeCoverZoom = (photo) =>
  clamp(Math.round((Math.max(BOX_W / photo.naturalWidth, BOX_H / photo.naturalHeight) / Math.min(BOX_W / photo.naturalWidth, BOX_H / photo.naturalHeight)) * 100), 100, 400);

export const slideFileName = (s) => {
  const base = `${s.brand}_${s.productName}${s.color ? "_" + s.color : ""}`.replace(/[^\w\-]+/g, "_");
  const tallas = s.sizes.map((x) => x.size).join("-");
  return `${base}${tallas ? "_" + tallas : ""}.png`;
};

export async function renderSlideCanvas(input, photo, logo) {
  const S = 2, W = 1080, H = 1200;
  const canvas = document.createElement("canvas");
  canvas.width = W * S;
  canvas.height = H * S;
  const ctx = canvas.getContext("2d");
  ctx.scale(S, S);
  ctx.textBaseline = "alphabetic";
  const F = "Arial, Helvetica, sans-serif";
  const rr = (x, y, w, h, r) => {
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + w, y, x + w, y + h, r);
    ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r);
    ctx.arcTo(x, y, x + w, y, r);
    ctx.closePath();
  };

  ctx.fillStyle = "#ecebe6";
  ctx.fillRect(0, 0, W, H);
  ctx.fillStyle = NAVY;
  ctx.fillRect(0, 0, W, 110);

  if (logo) {
    const lh = 78;
    const lw = (logo.naturalWidth / logo.naturalHeight) * lh;
    ctx.fillStyle = "#fff";
    rr(30, 10, lw + 12, 90, 6);
    ctx.fill();
    ctx.drawImage(logo, 36, 16, lw, lh);
  }

  const cat = (input.category || "").toUpperCase();
  if (cat) {
    ctx.font = `900 36px ${F}`;
    const catW = ctx.measureText(cat).width + 96;
    ctx.fillStyle = "#e6f0ff";
    rr(W - 30 - catW, 25, catW, 60, 4);
    ctx.fill();
    ctx.fillStyle = NAVY;
    ctx.textAlign = "center";
    ctx.fillText(cat, W - 30 - catW / 2, 68);
  }

  const bx = 40, by = 150, bw = BOX_W, bh = BOX_H;
  ctx.fillStyle = "#fff";
  ctx.fillRect(bx, by, bw, bh);
  if (photo) {
    const z = input.zoom / 100;
    const r = Math.min(bw / photo.naturalWidth, bh / photo.naturalHeight) * z;
    const dw = photo.naturalWidth * r, dh = photo.naturalHeight * r;
    ctx.save();
    ctx.beginPath();
    ctx.rect(bx, by, bw, bh);
    ctx.clip();
    ctx.drawImage(photo, bx + (bw - dw) / 2 + input.offX, by + (bh - dh) / 2 + input.offY, dw, dh);
    ctx.restore();
  }

  const rows = input.sizes
    .filter((s) => String(s.qty).trim() !== "" || String(s.size).trim() !== "")
    .map((s) => (String(s.qty).trim() !== "" && String(s.size).trim() !== "" ? `${s.qty} - ${s.size}` : String(s.qty).trim() !== "" ? String(s.qty) : String(s.size)));
  if (input.showSizes && rows.length) {
    const label = (input.sizesLabel || "TALLAS").toUpperCase();
    ctx.font = `900 26px ${F}`;
    let inner = ctx.measureText(label).width;
    ctx.font = `900 34px ${F}`;
    rows.forEach((t) => (inner = Math.max(inner, ctx.measureText(t).width)));
    const boxW = Math.max(200, inner + 56);
    const boxH = 22 + 26 + 8 + 12 + Math.max(1, rows.length) * 40 + 22;
    const sx = bx + bw - 20 - boxW, sy = by + 20;
    ctx.fillStyle = "rgba(10,31,92,0.95)";
    rr(sx, sy, boxW, boxH, 10);
    ctx.fill();
    ctx.strokeStyle = "rgba(255,255,255,0.35)";
    ctx.lineWidth = 2;
    rr(sx, sy, boxW, boxH, 10);
    ctx.stroke();
    ctx.fillStyle = "#fff";
    ctx.textAlign = "center";
    ctx.font = `900 26px ${F}`;
    ctx.fillText(label, sx + boxW / 2, sy + 44);
    ctx.strokeStyle = "rgba(255,255,255,0.45)";
    ctx.beginPath();
    ctx.moveTo(sx + 28, sy + 56);
    ctx.lineTo(sx + boxW - 28, sy + 56);
    ctx.stroke();
    ctx.font = `900 34px ${F}`;
    rows.forEach((t, i) => ctx.fillText(t, sx + boxW / 2, sy + 100 + i * 40));
  }

  const barY = by + bh + 40;
  ctx.fillStyle = NAVY;
  ctx.fillRect(0, barY, W, H - barY);
  ctx.textAlign = "left";
  ctx.fillStyle = "#fff";
  ctx.font = `900 50px ${F}`;
  ctx.fillText(input.brand || "", 40, barY + 70);
  ctx.font = `800 24px ${F}`;
  ctx.fillText((input.productName || "").toUpperCase(), 40, barY + 100);

  let px = 40;
  const py = barY + 124;
  const badge = (text, bg, fg) => {
    ctx.font = `900 34px ${F}`;
    const w = ctx.measureText(text).width + 36;
    ctx.fillStyle = bg;
    rr(px, py, w, 54, 6);
    ctx.fill();
    ctx.fillStyle = fg;
    ctx.fillText(text, px + 18, py + 38);
    px += w + 10;
  };
  if (input.showPrice && input.price) badge(`PVP: ${input.price}`, "#fff", NAVY);
  if (input.showOffer && input.offerPrice) badge(`OFERTA: ${input.offerPrice}`, "#e11d48", "#fff");

  ctx.fillStyle = "#fff";
  ctx.font = `400 20px ${F}`;
  const cy = barY + (H - barY) / 2 - (CONTACT.length * 29) / 2 + 22;
  CONTACT.forEach((t, i) => ctx.fillText(t, 660, cy + i * 29));

  if (input.slideNumber) {
    ctx.font = `900 34px ${F}`;
    ctx.textAlign = "left";
    const t = `#${input.slideNumber}`;
    const tw = ctx.measureText(t).width;
    ctx.fillStyle = "#facc15";
    ctx.fillRect(20, H - 64, tw + 24, 48);
    ctx.fillStyle = NAVY;
    ctx.fillText(t, 32, H - 28);
  }
  return canvas;
}
